<div class="custom-accordion">
  <ng-content></ng-content>
</div>
